import VuePortal from 'portal-vue';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import VueRouter from 'vue-router';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VuePortal);
Vue.use(VueApexCharts);

Vue.component('apexchart', VueApexCharts);

new Vue({
  render: (h) => h(App),
  router,
}).$mount('#app');
